export enum TradingModel {
  PLAY = 'PLAY',
  IMPRESSION = 'IMPRESSION',
}

export enum TradingTimeModel {
  PLAY = 'PLAY',
  TRADE = 'TRADE',
}
